module.exports = __webpack_public_path__ + "assets/certificate_pdf/20220812175220Certificate.8eb73ec0.pdf";